import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'

/* Utils */
import {
    Box,
    InputRightElement,
    IconButton,
    Spinner,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'

/* Components */
import Field from '../../components/field'

/* Fields */
import useNotifyMeFields from '../../components/forms/useNotifyMeFields'

/* Icons */
import {NotifyMeSubmitIcon} from '../icons/index'

const NotifyMeFields = ({
    form,
    prefix = '',
    sku,
    defaultEmail = '',
    isEmailReadOnly = false,
    isLoading = false,
    onEmailChange
}) => {
    const {formatMessage} = useIntl()
    const styles = useMultiStyleConfig('NotifyMe')
    const fields = useNotifyMeFields({form, prefix})

    useEffect(() => {
        form.setValue(`${prefix}notifyMeSKU`, sku)
    }, [sku])

    useEffect(() => {
        if (defaultEmail) {
            form.setValue(`${prefix}notifyMeEmail`, defaultEmail)
        }
    }, [defaultEmail])

    return (
        <Box>
            <Field
                {...fields?.notifyMeEmail}
                inputProps={({onChange}) => ({
                    isReadOnly: isEmailReadOnly,
                    autoComplete: 'email',
                    maxLength: 50,
                    paddingRight: '48px',
                    onChange: (event) => {
                        onChange(event)
                        onEmailChange?.(event)
                    }
                })}
            >
                <InputRightElement {...styles.submitButtonContainer}>
                    <IconButton
                        type="submit"
                        variant="unstyled"
                        aria-label={formatMessage({
                            defaultMessage: 'Submit',
                            id: 'pdp_notify_me_submit.aria_label'
                        })}
                        isLoading={isLoading}
                        spinner={<Spinner size="sm" {...styles.submitSpinner} />}
                        icon={<NotifyMeSubmitIcon {...styles.submitIcon} />}
                        {...styles.submitButton}
                    />
                </InputRightElement>
            </Field>

            <Field
                inputProps={styles.checkboxInputProps}
                labelProps={styles.checkboxLabelProps}
                {...fields?.notifyMeTermsAndConditions}
            />

            <Field
                {...fields?.notifyMeSKU}
                value={sku}
            />
        </Box>
    )
}

NotifyMeFields.propTypes = {
    form: PropTypes.object.isRequired,
    sku: PropTypes.string.isRequired,
    prefix: PropTypes.string,
    defaultEmail: PropTypes.string,
    isEmailReadOnly: PropTypes.bool,
    isLoading: PropTypes.bool,
    onEmailChange: PropTypes.func
}

export default NotifyMeFields

